import type { FC } from 'react'
import { RadioButton } from '@/components/commons/radio'
import { InputHelpText } from '@/components/ui/input-help-text'
import { type TKey, useTranslation } from '@/translations/i18n'

interface YesNoQuestionProps {
	title: string
	description?: string
	answerOptions: string[]
	value: string
	onChange: (value: string) => void
	name: string
	errorMessage?: string
	disabled?: boolean
	ref?: React.ForwardedRef<HTMLInputElement>
}

export const YesNoQuestion: FC<YesNoQuestionProps> = ({
	title,
	description,
	answerOptions,
	value,
	onChange,
	name,
	errorMessage,
	disabled = false,
	ref
}) => {
	const { t } = useTranslation()
	return (
		<div className='flex flex-col gap-2'>
			<div className='flex flex-col gap-1'>
				<p className='font-bold text-base text-neutral-900'>{title}</p>
				{description && (
					<p className='text-neutral-900 text-sm'>{description}</p>
				)}
			</div>
			<div className='flex gap-2.5'>
				{answerOptions.map((option, index) => (
					<RadioButton
						checked={value === option}
						disabled={disabled}
						id={`${name}-${option}`}
						key={option}
						label={t(
							`luxe_submissions:score_form.yes_no_options.${option}` as TKey
						)}
						name={name}
						onChange={() => onChange(option)}
						ref={index === 0 ? ref : undefined}
						value={option}
						variant='brand'
					/>
				))}
			</div>
			<InputHelpText error={errorMessage} />
		</div>
	)
}
